import { ITeamDisplayDTO } from '@/dtos';
import { get } from '../apiWrapper';

export async function getTeamDisplayDataAPI(year?: string): Promise<ITeamDisplayDTO[]> {
  let params = '';
  if (year != null && year.trim() != '') {
    params = `?year=${year}`;
  }

  const data = await get<ITeamDisplayDTO[]>(`/team-display${params}`);

  return data;
}
